import React from "react";

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 pb-24 md:pb-8">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-gray-800 mb-6">
          About UyirUdalFoods
        </h1>

        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-2xl font-bold text-green-600 mb-4">Our Story</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Welcome to UyirUdalFoods, your trusted destination for authentic and
            delicious snacks. We are passionate about bringing you the finest
            quality food products that remind you of home and traditional
            flavors.
          </p>
          <p className="text-gray-700 leading-relaxed">
            Founded with a mission to deliver happiness through food, we
            carefully select each product to ensure it meets our high standards
            of quality, taste, and freshness.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-2xl font-bold text-green-600 mb-4">
            Why Choose Us?
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <div className="flex items-start mb-4">
                <div className="text-3xl mr-3">✓</div>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">
                    Quality Assured
                  </h3>
                  <p className="text-gray-600 text-sm">
                    We source only the best products from trusted manufacturers
                  </p>
                </div>
              </div>
              <div className="flex items-start mb-4">
                <div className="text-3xl mr-3">🚚</div>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">
                    Fast Delivery
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Quick and reliable delivery to your doorstep
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className="flex items-start mb-4">
                <div className="text-3xl mr-3">💰</div>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">
                    Best Prices
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Competitive pricing with regular offers and discounts
                  </p>
                </div>
              </div>
              <div className="flex items-start mb-4">
                <div className="text-3xl mr-3">❤️</div>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">
                    Customer First
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Your satisfaction is our top priority
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-bold text-green-600 mb-4">
            Our Values
          </h2>
          <ul className="space-y-3">
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span className="text-gray-700">
                <strong>Authenticity:</strong> We believe in preserving
                traditional flavors and recipes
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span className="text-gray-700">
                <strong>Quality:</strong> Every product is carefully selected
                and tested
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span className="text-gray-700">
                <strong>Trust:</strong> Building long-term relationships with
                our customers
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span className="text-gray-700">
                <strong>Innovation:</strong> Constantly improving our service
                and offerings
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
